import {endorsementActions} from '../actions';

export default function endorsements(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case endorsementActions.SET_ENDORSEMENTS:
            return setEndorsements(newState, action);
        case endorsementActions.REQUEST_ENDORSEMENTS_REQUEST:
            return setEndorsements(newState, action);
        case endorsementActions.PUBLISH_ENDORSEMENTS_REQUEST:
            return setEndorsements(newState, action);
        case endorsementActions.REQUEST_ENDORSEMENTS_SUCCESS:
            return setPendingEndorsements(newState, action);
        case endorsementActions.PUBLISH_ENDORSEMENTS_SUCCESS:
            return publishEndorsement(newState, action);
        case endorsementActions.UNPUBLISH_ENDORSEMENTS_SUCCESS:
            return unpublishEndorsement(newState, action);
        case endorsementActions.DELETE_ENDORSEMENT_SUCCESS:
            return deleteEndorsement(newState, action);
        case endorsementActions.PUBLISH_ENDORSEMENTS_ERROR:
            return setEndorsements(newState, action);
        default:
            return newState;
    }
}

function setEndorsements(state, action) {
    delete action.type;
    state = Object.assign(state, {...action});
    return state;
}

function setPendingEndorsements( state, action ) {
    delete action.type;
    state.pending = state.pending.concat(action);
    return state;
}

function publishEndorsement( state, action ) {
    delete action.type;
    const currentEndorsement = state.received.find( endorsement => endorsement.body.id === action.body.id );
    currentEndorsement.body.is_visible = 1;
    state.published = state.published.concat(currentEndorsement);
    state.received = state.received.filter( endorsement => endorsement.body.id !== currentEndorsement.body.id );
    return state;
}

function unpublishEndorsement( state, action ) {
    delete action.type;
    const currentEndorsement = state.published.find( endorsement => endorsement.body.id === action.body.id );
    currentEndorsement.body.is_visible = 0;
    state.received = state.received.concat(currentEndorsement);
    state.published = state.published.filter( endorsement => endorsement.body.id !== currentEndorsement.body.id );
    return state;
}

function deleteEndorsement ( state, action ) {
    delete action.type;
    const endorsementIsPending = state.pending.find( endorsement => endorsement.body.id === action.body.id );
    endorsementIsPending
        ? state.pending = state.pending.filter( endorsement => endorsement.body.id !== action.body.id)
        : state.received = state.received.filter( endorsement => endorsement.body.id !== action.body.id );
    return state;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/endorsements.js